import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allOrders } from '@/mocks/data/transactions/orders'

import { api } from '@/utils/constants'

import { Order } from '@/types/operations/order'

export const getOrder = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.operations.orders.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const orderFound: Order = allOrders.find(
            (order) => order.id.toString() === id,
        )

        // Not found
        if (!orderFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<Order>(orderFound)
    },
)
